import { h } from 'preact';
import styled from 'styled-components';
import { decodeHtml } from '../../common/utils';

const StyledInvitationContentText = styled.div`
  outline: none;
  p{
    margin:0 0 10px;
  }
`;

export default props => (
  <StyledInvitationContentText
    className="invitationContentText"
    dangerouslySetInnerHTML={{ __html: decodeHtml(props.content) }}
  />
);
